import InfoIcon from '@mui/icons-material/Info';
import { Typography, useMediaQuery, useTheme } from '@mui/material';
import { memo, ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { InformationTooltip } from '../InformationTooltip';

export const MaterialTooltip = memo(function (): ReactElement {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <InformationTooltip
      tooltipElement={InfoIcon}
      fontSize={isMobile ? 'small' : 'medium'}
      tooltipContent={<Typography variant='body1'>{t('material.tooltipTitle')}</Typography>}
    />
  );
});
